import React, { FC, ReactNode } from 'react';

import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import {
    CardActionContainer,
    CardButtonItem,
    CardDescription,
    CardIcon,
    CardLinkItem,
} from '~/views/pages/dotcom/schedule/styles';
import { GameLink } from '~/views/pages/dotcom/schedule/types';

type PopperItemProps = {
    gameLink: GameLink;
    handleClose: () => void;
    isPlayoffSeriesPage: boolean;
};

const PopperItem: FC<PopperItemProps> = ({ gameLink, handleClose, isPlayoffSeriesPage }) => {
    // some of the buttons in the popper don't actually link to another location, but perform a call (i.e. open a modal)
    const isCallbackButton = !!gameLink.onClick;

    const itemContent: ReactNode = (
        <>
            {!isPlayoffSeriesPage && <CardIcon>{gameLink.icon && gameLink.icon}</CardIcon>}
            <CardDescription $isPlayoffSeriesPage={isPlayoffSeriesPage}>{gameLink.message}</CardDescription>
            {!isPlayoffSeriesPage && (
                <CardActionContainer>
                    <ChevronRightIcon />
                </CardActionContainer>
            )}
        </>
    );

    const onNonLinkButtonClick = (): void => {
        gameLink?.onClick?.();
        handleClose();
    };

    return isCallbackButton ? (
        <CardButtonItem onClick={onNonLinkButtonClick}>{itemContent}</CardButtonItem>
    ) : (
        <CardLinkItem href={gameLink.actionUrl} onClick={handleClose}>
            {itemContent}
        </CardLinkItem>
    );
};

export default PopperItem;
